import * as React from 'react';

import {Card} from 'shells/card/card';

import styles from './size-warning.module.css';

export function SizeWarning() {
    return (
        <div className={styles['size-warning']}>
            <Card hasBorder={true} hasShadow={true}>
                <div className='pad-16'>
                    The current window is too small to properly display the editor. Consider
                    resizing your browser window or adjusting your zoom setting.
                </div>
            </Card>
        </div>
    );
}
